import { Grid, styled } from '@mui/material'
import { ReactElement, ReactNode } from 'react'
import ErrorBoundary from '../ErrorBoundaries/ErrorBoundary'

const Main = styled('main')(() => ({
    flexGrow: 1,
    marginLeft: '10px',
    marginRight: '10px',
    width: `calc(100% - 20px)`,
    height: 'calc(100vh - 83px)',
    border: '1px solid #959595',
    borderRadius: '8px',
    marginBottom: '20px',
    position: 'fixed',
    top: '80px',
    padding: '24px',
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column',
}))

interface AuthenticatedLayoutProps {
    children: ReactNode
}

const UnAuthenticatedLayout = ({
    children,
}: AuthenticatedLayoutProps): ReactElement => {
    return (
        <Grid>
            <Main>
                <ErrorBoundary>{children}</ErrorBoundary>
            </Main>
        </Grid>
    )
}

export default UnAuthenticatedLayout
